<template>
  <div>
    <div v-for="(block, bi) in blocks" :key="block.id ?? bi" class="mb-4">
      <div class="text-caption font-weight-semibold mb-2">
        时段 {{ bi + 1 }}：{{ block.startTime }} — {{ block.endTime }}
      </div>
      <div class="ac-summary-table-wrap">
        <table class="ac-summary-table">
          <thead>
            <tr>
              <th>起始功率(kW)</th>
              <th>结束功率(kW)</th>
              <th>制冷始(℃)</th>
              <th>制冷末(℃)</th>
              <th>制热始(℃)</th>
              <th>制热末(℃)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, ri) in block.rows || []" :key="ri">
              <td>{{ row.startPowerKw }}</td>
              <td>{{ row.endPowerKw }}</td>
              <td>{{ row.coolStartC }}</td>
              <td>{{ row.coolEndC }}</td>
              <td>{{ row.heatStartC }}</td>
              <td>{{ row.heatEndC }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  blocks: { type: Array, default: () => [] },
})
</script>

<style scoped lang="scss">
.ac-summary-table-wrap {
  overflow-x: auto;
}

.ac-summary-table {
  width: 100%;
  min-width: 520px;
  border-collapse: collapse;
  font-size: 13px;
  th,
  td {
    border: 1px solid #edf2f6;
    padding: 8px 10px;
    text-align: center;
  }
  th {
    background: #f4f6fc;
    font-weight: 600;
    color: var(--color-text, #444a6d);
  }
}
</style>
